import { useState } from "react";
import { api } from "../lib/config";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { username, password });
      localStorage.setItem("admin_token", data.token);
      // Look up role from /admin/me so we redirect kiosko/logistica users
      // straight to /admin/logistica (they can't see the main admin dashboard).
      let role = "admin";
      try {
        const me = await api.get("/admin/me");
        role = me.data?.role || "admin";
      } catch { /* fall through with admin default */ }
      toast.success("Bienvenido");
      if (role === "admin") nav("/admin");
      else nav("/admin/logistica");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6 grain relative">
      <form
        onSubmit={submit}
        className="relative max-w-md w-full bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 lg:p-10"
        data-testid="admin-login-form"
      >
        <div className="flex items-center justify-center mb-6">
          <div className="w-14 h-14 rounded-full bg-gradient-to-br from-yellow-400 to-orange-600 flex items-center justify-center">
            <Lock className="w-7 h-7 text-black" />
          </div>
        </div>
        <h1 className="font-heading uppercase text-3xl text-center text-white mb-2">Panel Admin</h1>
        <p className="text-white/60 text-center text-sm mb-8">Operación Rescate 2026</p>

        <div className="space-y-4">
          <div>
            <Label htmlFor="user" className="text-white/80">Usuario</Label>
            <Input
              id="user"
              data-testid="admin-username-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-2 bg-white/10 border-white/20 text-white placeholder:text-white/40 h-12"
              placeholder="admin"
            />
          </div>
          <div>
            <Label htmlFor="pass" className="text-white/80">Contraseña</Label>
            <Input
              id="pass"
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-white/10 border-white/20 text-white placeholder:text-white/40 h-12"
              placeholder="••••••••"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-bold uppercase tracking-wider h-12"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Entrar"}
          </Button>
        </div>
      </form>
    </div>
  );
}
